// Session-preserving redirect helpers.
//
// Every "requires sign-in" action on the site now redirects to /signin with a
// `returnTo` + `action` pair, e.g. /signin?returnTo=/artwork/abc&action=buyNow.
// After a successful login the user lands back on the page they were on and
// the intended action is automatically resumed (see usePendingAction).

export interface ReturnTo {
  returnTo?: string;
  action?: string;
}

/** Build a /signin URL that returns the user to `path` after login. */
export const buildLoginUrl = (path: string, action?: string): string => {
  const params = new URLSearchParams({ returnTo: path });
  if (action) params.set('action', action);
  return `/signin?${params.toString()}`;
};

/** Read the returnTo/action pair out of a location.search string. */
export const getReturnTo = (search: string): ReturnTo => {
  const params = new URLSearchParams(search);
  return {
    returnTo: params.get('returnTo') || undefined,
    action: params.get('action') || undefined,
  };
};

/** Never redirect to external hosts, the auth pages themselves, or admin pages. */
export const sanitizeReturnTo = (path?: string | null): string => {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return '/';
  if (/^\/(signin|signup|signout|forgot-password)/i.test(path)) return '/';
  if (path.startsWith('/admin')) return '/';
  return path;
};